module.exports = __webpack_public_path__ + "img/sp_article_7.bcddf2eb.jpg";